module.exports = __webpack_public_path__ + "static/media/mudeyGreyNew.8493f9e6.jpg";